export default (props) => {
  const { className = "", style = {}, html = "" } = props;
  return (
    <div>
      <div
        style={style}
        className={`rich-content ${className}`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <style jsx global>
        {`
          .rich-content p {
            font-size: 16px;
            padding-top: 8px;
            padding-bottom: 8px;
            margin: 0;
            line-height: 26px;
          }
          .rich-content h1,
          .rich-content h2,
          .rich-content h3,
          .rich-content h4,
          .rich-content h5,
          .rich-content h6 {
            margin-top: 30px;
            margin-bottom: 15px;
            font-weight: bold;
          }
          .rich-content ul,
          .rich-content ol {
            margin-top: 8px;
            margin-bottom: 8px;
            padding-left: 25px;
          }

          .rich-content li {
            margin-top: 5px;
            margin-bottom: 5px;
            line-height: 26px;
            text-align: left;
            // font-weight: 500;
            font-weight: 400;
          }
          .rich-content {
            font-family: Optima-Regular, Optima, PingFangSC-light,
              PingFangTC-light, "PingFang SC", Cambria, Cochin, Georgia, Times,
              "Times New Roman";
          }
        `}
      </style>
    </div>
  );
};
